import { FMIP } from 'app/shared/constants/constants';
import axios, { AxiosResponse } from 'axios';

export interface IGeolocationApi {
    checkFMIP(imeiNumber: string, externalRef: string): Promise<AxiosResponse<FMIP>>;
    geoLocationPostAction(gelocationPostAction: any): Promise<AxiosResponse<any>>;
}

class GeolocationApi implements IGeolocationApi {
    async checkFMIP(imei: string, externalRef: string): Promise<AxiosResponse<FMIP>> {
        return await axios.get('/api/geolocalisation/FMIP/' + imei, { params: {externalRef} });
    }

    async geoLocationPostAction(gelocationPostAction: any): Promise<AxiosResponse<any>> {
        return await axios.post('/api/geolocalisation/geolocation-post-action', gelocationPostAction);
    }
}

const geolocationApi = new GeolocationApi();

export { geolocationApi };

